import React, { useState } from 'react'
import Button from "@mui/material/Button";
import Axios from "axios";
import { API_URL_UMS } from '../../../Constant';

const CreateInterfacePermission = (props) => {
    const { userID } = props;
    const [permission, setPermission] = useState({
        screen: "",
        subScreen: "",
        actionButton: "",
        referenceNumber: ""
    })
    const [screenError, setScreenError] = useState(null)
    const [subScreenError, setSubScreenError] = useState(null);
    const [success, setSucces] = useState(false)
    const { screen, subScreen, actionButton, referenceNumber } = permission;

    const handleFormControl = (e) => {
        setSubScreenError(null)
        setScreenError(null)
        setPermission({ ...permission, [e.target.name]: e.target.value })
    }

    const onPermissionSubmit = (e) => {
        e.preventDefault()
        if (screen === "" && subScreen === "") {
            setScreenError("Required")
            setSubScreenError("Required")
            return 0;
        }
        if (screen === "") {
            setScreenError("Required")
            return 0;
        }
        if (subScreen === "") {
            setSubScreenError("Required")
            return 0;
        }

        let postObject = {
            "parentScreen": screen,
            "childScreen": subScreen,
            "actionButton": actionButton,
            "referenceNumber": referenceNumber,
            "userId": userID
        }

        Axios({
            method: "POST",
            url: `${API_URL_UMS}/audit/permission`,
            data: postObject,
            headers: {
                "Content-Type": "application/json",
                "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
                "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
            },
        })
            .then(async (response) => {
                setSucces(true)
                setTimeout(() => {
                    setSucces(false)
                }, 5000)
            })
            .catch((err) => {
            });
    }

    return (
        <div className='row mt-3'>
            <div className='col-md-6 mx-auto card p-3'>
                <form className='formField'>
                    <div className="form-group row">
                        <label htmlFor="validationScreen" className="col-sm-4 col-form-label">Screen <span className='text-danger'>*</span></label>
                        <div className="col-sm-6">
                            <input type="text" name="screen" onChange={handleFormControl}
                                onKeyPress={(e) => {
                                    if (/[!-\/:-@[-`{-~ 0-9]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                className={`form-control ${screenError && "formValidation"}`} id="validationScreen" value={screen} />
                            <small id="validationScreen" className="form-text text-right text-danger">{screenError}</small>
                        </div>

                    </div>
                    <div className="form-group row">
                        <label htmlFor="validationSubScreen" className="col-sm-4 col-form-label">Sub Screen <span className='text-danger'>*</span></label>
                        <div className="col-sm-6">
                            <input type="text" name="subScreen" onChange={handleFormControl}
                                onKeyPress={(e) => {
                                    if (/[!-\/:-@[-`{-~ 0-9]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                className={`form-control ${subScreenError && "formValidation"}`} id="validationSubScreen" value={subScreen} />
                            <small id="validationSubScreen" className="form-text text-right text-danger">{subScreenError}</small>
                        </div>
                    </div>

                    <div className="form-group row">
                        <label htmlFor="validationActionButton" className="col-sm-4 col-form-label">Action Button</label>
                        <div className="col-sm-6">
                            <input type="text" name="actionButton" onChange={handleFormControl}
                                onKeyPress={(e) => {
                                    if (/[!-\/:-@[-`{-~ 0-9]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                className="form-control" id="validationActionButton" value={actionButton} />
                        </div>
                    </div>

                    <div className="form-group row">
                        <label htmlFor="referenceNumber" className="col-sm-4 col-form-label">Reference Number</label>
                        <div className="col-sm-6">
                            <input type="text" name="referenceNumber" onChange={handleFormControl} className="form-control" id="referenceNumber" value={referenceNumber} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 text-success text-center">
                            <span >{success && "Permission created Succefully!"}</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <Button
                                variant="contained"
                                className="btncolor"
                                size="small"
                                type="submit"
                                sx={{ m: 1 }}
                                onClick={onPermissionSubmit}
                            >
                                Create
                            </Button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    )
}

export default CreateInterfacePermission